/* Swaps the product gallery (slides, thumbnails, zoom pop-up) by selected plan.
   Sets come from a JSON block rendered by snippets/product-gallery-plans.liquid.
   Works on the PDP and the homepage featured product. */
(function () {
  const MAIN_WIDTHS = [390, 533, 720, 1000, 1500];
  const sized = (url, w) => {
    const u = new URL(url, window.location.href);
    u.searchParams.set('width', w);
    return u.toString();
  };
  const srcset = (url, widths) =>
    widths.map((w) => sized(url, w) + ' ' + w + 'w').join(', ');

  function init(dataEl) {
    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    const product = dataEl.closest('.product');
    const gallery = product && product.querySelector('media-gallery');
    const mainC = gallery && gallery.querySelector('.embla__container');
    if (!mainC) return;

    const mainComp = gallery.querySelector('embla-component');
    const thumbsC = gallery.querySelector('.embla-thumbs__container');
    const viewer = product.querySelector('gallery-viewer');
    const viewerC = viewer && viewer.querySelector('.embla__container');
    const viewerComp = viewer && viewer.querySelector('embla-component');
    const widget = product.querySelector('.tribe-product-subscription-widget');

    // Snapshot of the product's own images (used for One-time purchase).
    const original = {
      main: mainC.innerHTML,
      thumbs: thumbsC ? thumbsC.innerHTML : '',
      zoom: viewerC ? viewerC.innerHTML : '',
    };

    const protoOf = (html, selector) => {
      const t = document.createElement('template');
      t.innerHTML = html;
      const slides = Array.from(t.content.querySelectorAll(selector));
      return slides.find((li) => li.querySelector('img')) || null;
    };
    const protoMain = protoOf(original.main, '.embla__slide');
    const protoThumb = thumbsC ? protoOf(original.thumbs, '.embla-thumbs__slide') : null;
    const protoZoom = viewerC ? protoOf(original.zoom, '.embla__slide') : null;
    if (!protoMain) return;

    // Silent looping video for slot 1 (MP4 uploaded to Shopify files).
    const makeVideo = (it, zoom) => {
      const v = document.createElement('video');
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.loop = true;
      v.autoplay = true;
      v.preload = 'metadata';
      if (zoom) v.controls = true;
      if (it.poster) v.poster = it.poster;
      v.setAttribute('aria-label', it.alt || '');
      const src = document.createElement('source');
      src.src = it.src;
      src.type = it.mime || 'video/mp4';
           v.appendChild(src);
      // Some browsers need an explicit nudge to start autoplay once the video can play.
      v.addEventListener(
        'canplay',
        () => {
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        },
        { once: true },
      );
      return v;
    };

    const buildMain = (items) =>
      items.map((it, i) => {
        const li = protoMain.cloneNode(true);
        li.classList.remove('is-active');
        li.dataset.slideIndex = i;
        li.querySelectorAll('[data-index]').forEach((el) => (el.dataset.index = i));
        li.querySelectorAll('[data-media-id]').forEach((el) => (el.dataset.mediaId = 'plan-' + i));
        const img = li.querySelector('img');
        if (it.type === 'video') {
          const v = makeVideo(it, false);
          v.className = 'motion-reduce';
          v.style.objectFit = 'cover';
          img.replaceWith(v);
          return li;
        }
        img.src = sized(it.url, 533);
        img.srcset = srcset(it.url, MAIN_WIDTHS);
        img.alt = it.alt || '';
        img.removeAttribute('fetchpriority');
        img.loading = i === 0 ? 'eager' : 'lazy';
        return li;
      });

    const buildThumbs = (items) =>
      items.map((it, i) => {
        const li = protoThumb.cloneNode(true);
        li.classList.remove('embla-thumbs__slide--selected');
        li.dataset.slideIndex = i;
        li.querySelectorAll('[data-slide-index]').forEach((el) => (el.dataset.slideIndex = i));
        const img = li.querySelector('img');
        const thumbUrl = it.type === 'video' ? it.poster : it.url;
        if (it.type === 'video') li.setAttribute('data-video', '');
        else li.removeAttribute('data-video');
        if (thumbUrl) {
          img.src = sized(thumbUrl, 160);
          img.srcset = sized(thumbUrl, 160) + ' 160w';
        }
        img.alt = it.alt || '';
        return li;
      });

    const buildZoom = (items) =>
      items.map((it, i) => {
        const li = protoZoom.cloneNode(true);
        li.classList.remove('is-active');
        li.dataset.slideIndex = i;
        const img = li.querySelector('img');
        if (it.type === 'video') {
          const v = makeVideo(it, true);
          v.style.cssText = 'display:block;margin:0 auto;max-width:100%;max-height:90vh;';
          img.replaceWith(v);
          return li;
        }
        img.src = sized(it.url, 1600);
        img.srcset = srcset(it.url, [390, 533, 720, 1000, 1600]);
        img.alt = it.alt || '';
        return li;
      });

    const mark = () => {
      const api = mainComp && mainComp.emblaApi;
      if (!thumbsC || !api) return;
      const i = api.selectedScrollSnap();
      thumbsC.querySelectorAll('.embla-thumbs__slide').forEach((el, n) => {
        el.classList.toggle('embla-thumbs__slide--selected', n === i);
      });
    };

      // The theme pauses every video whenever the carousel slides. Restart the one on the active slide.
    const playActive = () => {
      const api = mainComp && mainComp.emblaApi;
      if (!api) return;
      const i = api.selectedScrollSnap();
      mainC.querySelectorAll('video').forEach((v) => {
        const slide = v.closest('.embla__slide');
        if (slide && Number(slide.dataset.slideIndex) === i) {
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        }
      });
    };

    const onSelect = () => {
      mark();
      setTimeout(playActive, 0);
    };

    let hooked = false;
    const hook = () => {
      const api = mainComp && mainComp.emblaApi;
      if (hooked || !api) return;
      hooked = true;
      api.on('select', onSelect);
      api.on('reInit', onSelect);
    };

       // Thumbnail clicks. The theme wires these up once, to the thumbnails that exist when the
    // carousel starts, and its drag handler can swallow clicks. Listening on the document in the
    // capture phase means swapped-in thumbnails always respond.
    if (thumbsC) {
      document.addEventListener(
        'click',
        (e) => {
          const li = e.target.closest && e.target.closest('.embla-thumbs__slide');
          if (!li || !thumbsC.contains(li)) return;
          const idx = Number(li.dataset.slideIndex);
          if (Number.isNaN(idx)) return;
          const host = thumbsC.closest('gallery-thumbs');
          const hostActive = host && host.getAttribute('data-is-disabled') !== 'true';
          if (hostActive && typeof gallery.thumbClickHandler === 'function') {
            gallery.thumbClickHandler(idx);
          } else {
            const api = mainComp && mainComp.emblaApi;
            if (api) api.scrollTo(idx);
          }
        },
        true,
      );
    }

    let current = 'original';

    const resolve = (key) => {
      if (key === 'otp') return 'original';
      if (data[key] && data[key].length) return key;
      const other = key === 'monthly' ? '3month' : 'monthly';
      return data[other] && data[other].length ? other : 'original';
    };

    const afterSwap = () => {
      const api = mainComp && mainComp.emblaApi;
      if (api) {
        api.reInit({ startIndex: 0 });
        hook();
      }
      const vApi = viewerComp && viewerComp.emblaApi;
      if (vApi) vApi.reInit({ startIndex: 0 });
           requestAnimationFrame(() => {
        if (mainComp && mainComp.handleSelect && api) mainComp.handleSelect();
        mark();
        setTimeout(playActive, 0);
      });
    };

    const apply = (key) => {
      const target = resolve(key);
      if (target === current) return;
      if (target === 'original') {
        mainC.innerHTML = original.main;
        mainC.querySelectorAll('.is-active').forEach((el) => el.classList.remove('is-active'));
        if (thumbsC) {
          thumbsC.innerHTML = original.thumbs;
          thumbsC.style.removeProperty('--thumb-count');
          thumbsC
            .querySelectorAll('.embla-thumbs__slide--selected')
            .forEach((el) => el.classList.remove('embla-thumbs__slide--selected'));
        }
        if (viewerC) viewerC.innerHTML = original.zoom;
      } else {
        const items = data[target];
        mainC.replaceChildren(...buildMain(items));
        if (thumbsC && protoThumb) thumbsC.replaceChildren(...buildThumbs(items));
        if (thumbsC) thumbsC.style.setProperty('--thumb-count', String(items.length));
        if (viewerC && protoZoom) viewerC.replaceChildren(...buildZoom(items));
      }
      current = target;
      afterSwap();
    };

    const plan = () => {
      if (!widget) return '3month';
      if (widget.classList.contains('is-otp')) return 'otp';
      const card = widget.querySelector('.ditto-plan.active');
      return card && card.dataset.frequency === 'monthly' ? 'monthly' : '3month';
    };

    const sync = () => apply(plan());
    if (widget) {
      new MutationObserver(sync).observe(widget, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
      });
    }

       sync();
    gallery.classList.add('is-plan-ready');

    const start = () =>
      setTimeout(() => {
        hook();
        playActive();
      }, 0);
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  }

  const run = () =>
    document.querySelectorAll('script[data-gallery-plans]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();